/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";

export const offerCurrencyConversionFactorRegExp = new RegExp(
  "^(?:[1-9][0-9]*(?:\\.[0-9]*[1-9])?|0\\.[0-9]*[1-9])$",
);

export const OfferCurrencyConversion = zod
  .object({
    sourceCurrency: zod.enum(["EUR", "USD", "GBP", "NOK"]),
    targetCurrency: zod.enum(["EUR", "USD", "GBP", "NOK"]),
    factor: zod.string().regex(offerCurrencyConversionFactorRegExp),
  })
  .describe(
    "Actual foreign conversion. Source matches native unitPrice; target matches quotation Currency. Canonical positive plain decimal factor has no exponent, sign or redundant zeros. Output only.",
  );

export type OfferCurrencyConversion = zod.input<typeof OfferCurrencyConversion>;
export type OfferCurrencyConversionOutput = zod.output<typeof OfferCurrencyConversion>;
